import { isValidCnpj } from "./cnpj";

export function validarLinha(row, rowNumber, nomeAba) {
  const erros = [];
  const sucessos = [];

  function padraoCampo(campo) {
    return `${campo}: É inválido;`;
  }

  if (nomeAba === "Unidades") {
    const valores = {
      cnpj: row.getCell(1).value,
      apelido: row.getCell(2).value,
      tipo: row.getCell(3).value,
      endereco: row.getCell(4).value,
      cidade: row.getCell(5).value,
      estado: row.getCell(6).value,
      cep: row.getCell(7).value,
      objeto_social: row.getCell(8).value,
      data_baixa: row.getCell(9).value,
      obs: row.getCell(10).value,
      cnae_primario: row.getCell(11).value,
      cnaes_secundarios: row.getCell(12).value,
      exterior: row.getCell(13).value,
    };

    const errosLinha = [];

    if (!valores.cnpj) {
      errosLinha.push(padraoCampo("cnpj"));
    } else {
      const cnpjNumeros = String(valores.cnpj).replace(/\D/g, "");
      if (cnpjNumeros.length !== 14 || !isValidCnpj(cnpjNumeros)) {
        errosLinha.push(padraoCampo("cnpj"));
      }
    }

    if (!valores.apelido) errosLinha.push(padraoCampo("apelido"));

    if (valores.tipo == null || ![1, 2].includes(valores.tipo)) {
      errosLinha.push(padraoCampo("tipo"));
    }

    if (valores.estado && !/^[A-Z]{2}$/.test(valores.estado)) {
      errosLinha.push(padraoCampo("estado"));
    }

    if (valores.cep) {
      const cepNumeros = String(valores.cep).replace(/\D/g, "");
      if (cepNumeros.length !== 8) errosLinha.push(padraoCampo("cep"));
    }

    if (valores.data_baixa) {
      const data = valores.data_baixa;
      if (!(data instanceof Date) && !/^\d{2}\/\d{2}\/\d{4}$/.test(data)) {
        errosLinha.push(padraoCampo("data_baixa"));
      }
    }

    if (valores.exterior && !["SIM", "NÃO"].includes(valores.exterior.toUpperCase())) {
      errosLinha.push(padraoCampo("exterior"));
    }

    const cnaePrimario = valores.cnae_primario;
    if (cnaePrimario) {
      const cnaeStr = String(cnaePrimario).replace(/\D/g, "");
      if (cnaeStr.length > 10 || !/^\d+$/.test(cnaeStr)) {
        errosLinha.push(padraoCampo("cnae_primario"));
      }
    }

    ["endereco", "cidade", "objeto_social", "obs", "cnaes_secundarios"].forEach(campo => {
      if (valores[campo] && typeof valores[campo] !== "string") {
        errosLinha.push(padraoCampo(campo));
      }
    });

    if (valores.cnaes_secundarios) {
      const cnaesArray = valores.cnaes_secundarios.split(",").map(c => c.trim());
      const invalidCnaes = cnaesArray.filter(c => !/^\d+$/.test(c));
      if (invalidCnaes.length > 0) errosLinha.push(padraoCampo("cnaes_secundarios"));
    }

    if (errosLinha.length > 0) erros.push(`${errosLinha.join(" ")}`);
    else sucessos.push({ ...valores });
  }

  if (nomeAba === "Empresas") {
    const valores = {
      nome_acesso: row.getCell(1).value,
      cnpj: row.getCell(2).value,
      razao_social: row.getCell(3).value,
      apelido: row.getCell(4).value,
      tipo: row.getCell(5).value,
      sisbacen_login: row.getCell(6).value,
      sisbacen_senha: row.getCell(7).value,
      mes_encerramento: row.getCell(8).value,
      capital_social_subscrito: row.getCell(9).value,
      capital_social_integralizado: row.getCell(10).value,
      data_limite: row.getCell(11).value,
      quotas: row.getCell(12).value,
      eppme: row.getCell(13).value,
      obs: row.getCell(14).value,
      def: row.getCell(15).value,
      tributario: row.getCell(16).value,
    };

    const errosLinha = [];

    if (!valores.cnpj) {
      errosLinha.push(padraoCampo("cnpj"));
    } else {
      const cnpjNumeros = String(valores.cnpj).replace(/\D/g, "");
      if (cnpjNumeros.length !== 14 || !isValidCnpj(cnpjNumeros)) {
        errosLinha.push(padraoCampo("cnpj"));
      }
    }

    if (!valores.razao_social || typeof valores.razao_social !== "string") {
      errosLinha.push(padraoCampo("razao_social"));
    }

    if (
      valores.tipo == null ||
      isNaN(Number(valores.tipo)) ||
      Number(valores.tipo) < 1 ||
      Number(valores.tipo) > 12
    ) {
      errosLinha.push(padraoCampo("tipo"));
    }

    if (
      valores.mes_encerramento &&
      (isNaN(Number(valores.mes_encerramento)) ||
        Number(valores.mes_encerramento) < 0 ||
        Number(valores.mes_encerramento) > 12)
    ) {
      errosLinha.push(padraoCampo("mes_encerramento"));
    }

    ["capital_social_subscrito", "capital_social_integralizado", "quotas"].forEach(campo => {
      if (valores[campo] && isNaN(Number(valores[campo]))) {
        errosLinha.push(padraoCampo(campo));
      }
    });

    ["eppme", "def", "tributario"].forEach(campo => {
      if (valores[campo] && !["SIM", "NÃO"].includes(valores[campo].toUpperCase())) {
        errosLinha.push(padraoCampo(campo));
      }
    });

    if (!valores.nome_acesso || typeof valores.nome_acesso !== "string") {
      errosLinha.push(padraoCampo("nome_acesso"));
    }

    ["sisbacen_login", "obs", "apelido"].forEach(campo => {
      if (valores[campo] && typeof valores[campo] !== "string") {
        errosLinha.push(padraoCampo(campo));
      }
    });

    if (valores.sisbacen_senha && typeof valores.sisbacen_senha !== "string") {
      errosLinha.push(padraoCampo("sisbacen_senha"));
    }

    if (valores.data_limite && !(valores.data_limite instanceof Date)) {
      errosLinha.push(padraoCampo("data_limite"));
    }

    if (errosLinha.length > 0) erros.push(`${errosLinha.join(" ")}`);
    else sucessos.push({ ...valores });
  }

  return { erros, sucessos };
}


export function retornarLinhas(row, rowNumber, nomeAba) {
  const sucessos = [];


  if (nomeAba === "Unidades") {
    const valores = {
      numero_linha: rowNumber,
      cnpj: row.getCell(1).value,
      apelido: row.getCell(2).value,
      tipo: row.getCell(3).value,
      endereco: row.getCell(4).value,
      cidade: row.getCell(5).value,
      estado: row.getCell(6).value,
      cep: row.getCell(7).value,
      objeto_social: row.getCell(8).value,
      data_baixa: row.getCell(9).value,
      obs: row.getCell(10).value,
      cnae_primario: row.getCell(11).value,
      cnaes_secundarios: row.getCell(12).value,
      exterior: row.getCell(13).value,
    };


    sucessos.push({ ...valores });
  }

  if (nomeAba === "Empresas") {
    const valores = {
      numero_linha: rowNumber,
      nome_acesso: row.getCell(1).value,
      cnpj: row.getCell(2).value,
      razao_social: row.getCell(3).value,
      apelido: row.getCell(4).value,
      tipo: row.getCell(5).value,
      sisbacen_login: row.getCell(6).value,
      sisbacen_senha: row.getCell(7).value,
      mes_encerramento: row.getCell(8).value,
      capital_social_subscrito: row.getCell(9).value,
      capital_social_integralizado: row.getCell(10).value,
      data_limite: row.getCell(11).value,
      quotas: row.getCell(12).value,
      eppme: row.getCell(13).value,
      obs: row.getCell(14).value,
      def: row.getCell(15).value,
      tributario: row.getCell(16).value,
    };
    sucessos.push({ ...valores });
  }

  if (nomeAba === "Empresas") {
    const valores = {
      numero_linha: rowNumber,
      nome_acesso: row.getCell(1).value,
      cnpj: row.getCell(2).value,
      razao_social: row.getCell(3).value,
      apelido: row.getCell(4).value,
      tipo: row.getCell(5).value,
      sisbacen_login: row.getCell(6).value,
      sisbacen_senha: row.getCell(7).value,
      mes_encerramento: row.getCell(8).value,
      capital_social_subscrito: row.getCell(9).value,
      capital_social_integralizado: row.getCell(10).value,
      data_limite: row.getCell(11).value,
      quotas: row.getCell(12).value,
      eppme: row.getCell(13).value,
      obs: row.getCell(14).value,
      def: row.getCell(15).value,
      tributario: row.getCell(16).value,
    };
    sucessos.push({ ...valores });
  }


  return sucessos
}


export function validarColunas(worksheet) {
  const regrasColunas = {
    Empresas: [
      "cnpj", "razao_social", "tipo", "sisbacen_login", "sisbacen_senha",
      "mes_encerramento", "capital_social_subscrito", "capital_social_integralizado",
      "data_limite", "quotas", "eppme", "obs", "apelido", "def", "tributario", "nome_acesso"
    ],
    Unidades: [
      "cnpj", "apelido", "tipo", "endereco", "cidade", "estado", "cep", "objeto_social",
      "data_baixa", "obs", "cnae_primario", "cnaes_secundarios", "exterior"
    ]
  };

  const nomeAba = worksheet.name;
  const colunasEsperadas = regrasColunas[nomeAba];

  if (!colunasEsperadas) {
    return [`Aba "${nomeAba}" não possui regras de validação definidas.`];
  }

  const header = worksheet.getRow(1).values.map(v => (typeof v === "string" ? v.trim() : v));

  const faltando = colunasEsperadas.filter((col) => !header.includes(col));

  if (faltando.length > 0) {
    return [`Na aba "${nomeAba}" faltam colunas obrigatórias: ${faltando.join(", ")}`];
  }

  return [];
}

